<template>
  <div>
    <div class="title_text">
      <div>
        <Icon type="ios-bookmark" size="18" color="#0466dd" />
        <span class="title_text2">解除劳动关系证明申请-功能配置</span>
      </div>
    </div>
    <div class="jiezhi_peizhi_div">
      <div class="setting_input">
        <div class="setting_input_title">解除（终止）协议模板：</div>
        <div style="width: 100%">
          <Select v-model="select_relieve_template_id" @on-change="relieve_template_idchange">
            <Option :value="item.value" v-for="(item, i) in relieve_template_list" :key="i">{{ item.label }}</Option>
          </Select>
        </div>
        <div v-if="select_relieve_template_id" class="look_template" @click="look_template">
          <span>
            <Icon type="ios-eye-outline" />查看模板
          </span>
        </div>

      </div>
    </div>
    <div class="title_text">
      <div>
        <Icon type="ios-bookmark" size="18" color="#0466dd" />

        <span class="title_text2">解除劳动关系证明申请-审批</span>
      </div>

      <div class="query_box"></div>
    </div>
    <div class="data_div">
      <div class="card_main">
        <Spin fix v-if="table_loading"></Spin>

        <div class="count_card" @click="click_count('待审核', 0)">
          <div>
            <CountUp :end="daishen_count" :duration="4" ref="count" v-font="18" />
          </div>

          <div class="count_title2">待审核</div>
        </div>

        <div class="count_card" @click="click_count('审核通过', 1)">
          <div>
            <CountUp :end="tongguo_count" :duration="4" ref="count" v-font="18" />
          </div>

          <div class="count_title2">审核通过</div>
        </div>

        <div class="count_card" @click="click_count('审核不通过', 2)">
          <div>
            <CountUp :end="butongguo_count" :duration="4" ref="count" v-font="18" />
          </div>

          <div class="count_title2">审核不通过</div>
        </div>
      </div>
    </div>

    <Drawer :title="drawer_title" :closable="true" v-model="drawer_show" width="95">
      <div>
        <div class="action_div" v-if="detail_data_type == 0">
          <Button :loading="confirm_loading" size="small" @click="confirm" type="primary" style="font-size: 13px">
            <Icon type="md-checkmark-circle" />同意
          </Button>
          <Button @click="refuse" :loading="confirm_loading" size="small" type="error"
            style="font-size: 13px; margin-left: 10px">
            <Icon type="md-close-circle" />拒绝
          </Button>
        </div>
        <Table ref="table" :height="windowHeight - 110" size="small" :columns="columns"
          @on-selection-change="table_change" :data="table_data">
          <template #pdf_fill_url="{ row }">
            <span class="view_pdf" @click="view_fill_pdf(row)">
              <Icon type="ios-eye-outline" />查看PDF
            </span>
          </template>
          <template #contract_url="{ row }">
            <span v-if="row.contract_url" class="view_pdf" @click="view_contract(row)">
              <Icon type="ios-eye-outline" />查看电子合同
            </span>
          </template>
        </Table>
      </div>
    </Drawer>

    <Modal v-model="refuse_show" title="审核拒绝理由" :mask-closable="false" :footer-hide="true" width="330">
      <div>
        <Input v-model="audit_remarks" placeholder="请输入理由.." style="width: 300px" />
      </div>
      <div class="refuse_button">
        <Button type="error" @click="refuse_http"> 确认拒绝</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { http, open_new_page, get_view_file_url } from "@/utils/http.js";

export default {
  name: "relieve_data",
  data() {
    return {
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度
      table_loading: false,
      project_id: "",
      select_relieve_template_id: null,
      relieve_template_list: [],

      butongguo_count: 0,
      butongguo_id_list: [],
      daishen_count: 0,
      daishen_id_list: [],
      tongguo_count: 0,
      tongguo_id_list: [],

      drawer_title: "",
      drawer_show: false,
      detail_data_type: 0,

      columns: [],
      table_data: [],
      table_select_data: [],
      audit_remarks: "",
      confirm_loading: false,
      refuse_show: false,
      template_file_url: ""
    };
  },

  methods: {
    view_contract(row) {
      console.log(row);
      get_view_file_url(row.contract_url)

    },

    table_change(e) {
      this.table_select_data = e;
    },

    refuse_http() {
      var audit_id_list = [];
      for (var i = 0; i < this.table_select_data.length; i++) {
        audit_id_list.push(this.table_select_data[i]["audit_id"]);
      }
      if (audit_id_list.length < 0) {
        this.$Message.error("请至少选一位");
        return;
      }
      this.confirm_loading = true;

      var obj = {
        project_id: this.project_id,
        audit_id_list: audit_id_list,
        audit_status: 2,
        audit_remarks: this.audit_remarks,
      };
      var that = this;
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/project_detail/relieve/contract_submit",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success(res.msg);
            that.click_count_request();
            that.get_project_relieve_data();
            that.refuse_show = false;
          } else {
            that.$Message.error(res.msg);
          }
          that.confirm_loading = false;
        })
        .catch((res) => {
          that.confirm_loading = false;

          console.log(res, "请求出错");
        });
    },

    refuse() {
      this.refuse_show = true;
    },
    confirm() {
      var audit_id_list = [];
      for (var i = 0; i < this.table_select_data.length; i++) {
        audit_id_list.push(this.table_select_data[i]["audit_id"]);
      }
      if (audit_id_list.length < 0) {
        this.$Message.error("请至少选一位");
        return;
      }
      this.confirm_loading = true;

      var obj = {
        project_id: this.project_id,
        audit_id_list: audit_id_list,
        audit_status: 1,
        audit_remarks: "审批通过",
      };
      var that = this;
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/project_detail/relieve/contract_submit",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success(res.msg);
            that.click_count_request();
            that.get_project_relieve_data();
          } else {
            that.$Message.error(res.msg);
          }
          that.confirm_loading = false;
        })
        .catch((res) => {
          that.confirm_loading = false;

          console.log(res, "请求出错");
        });
    },

    view_fill_pdf(row) {
      console.log(row);
      get_view_file_url(row.pdf_url);
    },

    click_count(title, status) {
      this.drawer_title = title;
      this.detail_data_type = status;
      this.drawer_show = true;

      this.click_count_request();
    },

    click_count_request() {
      var audit_id_list = [];
      if (this.detail_data_type == 0) {
        audit_id_list = this.daishen_id_list;
      }
      if (this.detail_data_type == 1) {
        audit_id_list = this.tongguo_id_list;
      }
      if (this.detail_data_type == 2) {
        audit_id_list = this.butongguo_id_list;
      }

      var obj = {
        project_id: this.project_id,
        audit_status: this.detail_data_type,
        audit_id_list: audit_id_list,
      };
      var that = this;
      http(
        "post",
        process.env.VUE_APP_HOST +
        "/my_project/project_detail/relieve/project_relieve_data_detail",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.columns = res.data.columns;
            that.table_data = res.data.detail_list;
          } else {
            that.$Message.error(res.msg);
          }
        })
        .catch((res) => {
          that.table_loading = false;

          console.log(res, "请求出错");
        });
    },
    get_project_relieve_data() {
      var obj = {
        project_id: this.project_id,
      };
      var that = this;
      http(
        "post",
        process.env.VUE_APP_HOST +
        "/my_project/project_detail/relieve/project_relieve_data",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            this.butongguo_count = res.data.butongguo_count;
            this.butongguo_id_list = res.data.butongguo_id_list;
            this.daishen_count = res.data.daishen_count;
            this.daishen_id_list = res.data.daishen_id_list;
            this.tongguo_count = res.data.tongguo_count;
            this.tongguo_id_list = res.data.tongguo_id_list;
          } else {
            that.$Message.error(res.msg);
          }
        })
        .catch((res) => {
          that.table_loading = false;

          console.log(res, "请求出错");
        });
    },

    get_contract_list() {
      var obj = {};
      var that = this;
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/project_detail/relieve/template_list",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.relieve_template_list = res.data.template_list;
          } else {
            that.$Message.error(res.msg);
          }
        })
        .catch((res) => {
          that.table_loading = false;

          console.log(res, "请求出错");
        });
    },
    get_project_relieve_template() {
      var that = this;

      var obj = {
        project_id: this.project_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/project_detail/relieve/project_template",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.select_relieve_template_id = res.data.template_id;
            that.template_file_url = res.data.template_file_url
            setTimeout(function () {
              that.get_contract_list();
            }, 50);
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.table_loading = false;
        })
        .catch((res) => {
          that.table_loading = false;

          console.log(res, "请求出错");
        });
    },

    open(project_id) {
      this.project_id = project_id;
      this.get_project_relieve_template();
      this.get_project_relieve_data();
    },

    update_project_relieve_template() {
      var that = this;

      var obj = {
        project_id: this.project_id,
        template_id: this.select_relieve_template_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST +
        "/my_project/project_detail/relieve/project_template_update",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.table_loading = false;
        })
        .catch((res) => {
          that.table_loading = false;

          console.log(res, "请求出错");
        });
    },
    relieve_template_idchange(e) {
      console.log("更新");
      // console.log(this.select_relieve_template_id);
      this.update_project_relieve_template();
    },

    look_template() {
      open_new_page(this.template_file_url)
      
    }
  },
};
</script>

<style scoped>
.look_template {
  width: 80px;
  display: flex;
  justify-content: center;
  flex-shrink: 0;
  cursor: pointer;
  color: rgb(102, 102, 255)
}

.refuse_button {
  margin: 20px 10px 0 10px;
  display: flex;
  justify-content: flex-end;
}

.action_div {
  display: flex;
  justify-content: flex-end;
}

.view_pdf {
  cursor: pointer;
  color: #0466dd;
}

.jiezhi_peizhi_title {
  width: 170px;
  flex-shrink: 0;
}

.jiezhi_peizhi_div {
  padding: 10px 15px;
}

.jiezhi_peizhi_div2 {
  padding: 10px 15px;
}

.confirm_div {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.setting_input {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.setting_input_title {
  width: 170px;
  flex-shrink: 0;
}

.icon2 {
  font-size: 18px;
}

.left_btn {
  display: flex;
  align-items: center;
}

.is_hexiao_div {
  display: flex;
  align-items: center;
}

.page_1 {
  padding-top: 3px;
  display: flex;
  justify-content: center;
}

.del_jiezhi {
  color: #f10800;
  cursor: pointer;
}

.fafang_time {
  cursor: pointer;
  color: #425dc0;
}

.search_box {
  padding-bottom: 10px;
}

.audit_box2_title {
  margin-bottom: 10px;
}

.audit_box {
  margin: 10px 0;
  display: flex;
  align-items: center;
}

.download_box_ts {
  background: #f82323;
  color: #fff;
  padding: 1px 10px;
  font-size: 13px;
  border-radius: 3px;
}

.download_box_right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.download_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 10px;
}

.table_card_scroll {
  height: calc(100vh - 90px);
  overflow: auto;
  position: relative;
}

.jiezhi_box {
  border-top: 1px dashed #ccc;
  margin: 10px 0 10px 0;
  padding-top: 10px;
}

.create_time {
  font-size: 12px;
  text-align: right;
}

.name {
  font-size: 13px;
  font-weight: 600;
  color: #000;
}

.card_inner {
  font-size: 13px;
  color: #333;
  display: flex;
  align-items: center;
}

.table_card {
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  padding: 10px;
  margin-bottom: 10px;
}

.title_text2 {
  font-weight: 600;
}

.export_table {
  font-size: 12px;
  color: #0466dd;
  font-weight: 300;
  margin-right: 10px;
  display: flex;
  align-items: center;
  cursor: pointer;
  letter-spacing: 1px;
}

.title_text {
  margin: 0px 10px 0 10px;
  font-size: 14px;
  color: #333;
  border-bottom: 1px solid #ddd;
  padding: 10px 10px 5px 0px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  letter-spacing: 2px;
}

.card_main {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
  position: relative;
}

.count_title {
  font-size: 13px;
  color: #333;
  margin-top: 5px;
}

.count_title2 {
  font-size: 13px;
  /* margin-top: 5px; */
}

.fafang_receipt {
  color: #0466dd;
}

.count_card {
  margin: 0 10px 10px 0;
  cursor: pointer;
  height: 65px;
  padding: 10px 10px 5px 10px;
  width: 110px;
  border-radius: 5px;

  background-color: #fff;
  text-align: center;
  border: 1px solid #b8bef7;
}

.count_card:hover {
  background-color: #0466dd;
  color: #fff;
}

.data_div {
  padding: 10px;
  border-radius: 5px;
}

.query_box {
  display: flex;
  justify-content: flex-end;
}
</style>
